import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

type UserRole = 'free' | 'pro' | 'admin' | 'proplus';

export const useUserRole = (userId: string | undefined) => {
  const [role, setRole] = useState<UserRole>('free');
  const [loading, setLoading] = useState(true);
  const [loadedUserId, setLoadedUserId] = useState<string | undefined>();

  useEffect(() => {
    if (!userId) {
      setRole('free');
      setLoading(false);
      setLoadedUserId(undefined);
      return;
    }

    setLoading(true);
    const fetchRole = async () => {
      try {
        const { data, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', userId)
          .single();

        if (error) throw error;
        setRole(data?.role || 'free');
      } catch (error) {
        console.error('Error fetching user role:', error);
        setRole('free');
      } finally {
        setLoadedUserId(userId);
        setLoading(false);
      }
    };

    fetchRole();
  }, [userId]);

  return { 
    role, 
    isPro: role === 'pro' || role === 'admin' || role === 'proplus',
    isProPlus: role === 'proplus' || role === 'admin',
    loading: loading || (!!userId && loadedUserId !== userId),
  };
};
